import { Widget, WIDGET_MATCHDAY_SELECTOR } from "@gaming/srvg-classes-core";


export class MatchdaySelectorWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#matchdaySelectorWidget';
        super( options );

        this.name = 'widgetmatchdayselector';
        this.widgetName = options.widgetName || WIDGET_MATCHDAY_SELECTOR;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addMatchdaySelectorWidget();
        super.handleDomInstantiated();
    }

    /**
     * add matchday selector widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addMatchdaySelectorWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

}
